import { FEATURE_CAPTURE_ADDRESS_SELL_SCREEN } from '../../../../constants'
import { hasUnknownLineItems } from '../../../../functions/sale'
import { FulfilmentType } from '../../../../models/fulfilment'
import { useAppSelector } from '../../../../state/hooks'
import {
  selectFulfilmentNoteIsInvalid,
  selectLineItems,
  selectNoteIsInvalid,
  selectSaleFulfilmentDetail,
  selectUnknownLineItems,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import {
  selectHasLineItemError,
  selectIsFinalisingSale,
  selectIsWaitingForWorkflows,
} from '../../../../state/slices/uiStateSlice'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { useLineItemFulfillmentAddressDetails } from '../../sale-line-item/fulfilment/popover/hooks'
import { AddressErrorsStatus } from '../../sale-line-item/fulfilment/popover/hooks/useLineItemFulfillmentAddressDetails'
import { useUnfulfilledSaleInvalidCustomer } from '../../sale-unfulfilled/useUnfulfilledSaleInvalidCustomer'

export const useCanTransitionToPaymentScreen = () => {
  const {
    isUnfulfilledSaleInvalidCustomer,
    isUnfulfilledSaleMissingCustomerContact,
  } = useUnfulfilledSaleInvalidCustomer()
  const lineItems = useAppSelector(selectLineItems)
  const unknownLineItems = useAppSelector(selectUnknownLineItems)
  const lineItemError = useAppSelector(selectHasLineItemError)
  const isFinalisingSale = useAppSelector(selectIsFinalisingSale)
  const isWaitingForWorkflows = useAppSelector(selectIsWaitingForWorkflows)

  const fulfilmentNoteInvalid = useAppSelector(selectFulfilmentNoteIsInvalid)
  const lineItemNoteInvalid = useAppSelector(selectNoteIsInvalid)

  const isCaptureAddressSellScreenEnabled = getFeatureFromCache(
    FEATURE_CAPTURE_ADDRESS_SELL_SCREEN
  )
  const fulfillmentDetail = useAppSelector(selectSaleFulfilmentDetail)
  const isFulfillmentDetailInvalid =
    useLineItemFulfillmentAddressDetails(fulfillmentDetail).status !==
    AddressErrorsStatus.CORRECTSHIPPING_CORRECTBILLING
  const hasDeliveryLineItems = lineItems.some(
    lineItem => lineItem.fulfilmentType === FulfilmentType.DELIVERY
  )
  const isNotNewSale = lineItems?.some(lineItem => !!lineItem.id)
  const isDeliveryFulfillmentInvalid =
    isCaptureAddressSellScreenEnabled &&
    hasDeliveryLineItems &&
    isFulfillmentDetailInvalid &&
    !isNotNewSale

  return (
    !isFinalisingSale &&
    !isWaitingForWorkflows &&
    lineItems.length &&
    !hasUnknownLineItems({ unknownLineItems }) &&
    !lineItemError &&
    !fulfilmentNoteInvalid &&
    !lineItemNoteInvalid &&
    !isDeliveryFulfillmentInvalid &&
    !(
      isUnfulfilledSaleInvalidCustomer ||
      isUnfulfilledSaleMissingCustomerContact
    )
  )
}
